import get from 'lodash/get';
import { createSelector } from 'reselect';
import { ALERT_MODULE_NAME, EMAIL_STATE_NAME } from '../constants';
import { getSearchParameterWhatD } from '~/Serp/selectors';

export const getAlertError = state => get(state[ALERT_MODULE_NAME], [EMAIL_STATE_NAME, 'error']);

export const getAlertFormError = state =>
  get(state[ALERT_MODULE_NAME], [EMAIL_STATE_NAME, 'formError']);

export const getAlertsAlreadyCreated = state =>
  get(state[ALERT_MODULE_NAME], [EMAIL_STATE_NAME, 'alreadyCreated']);

export const isLoadingSelector = state =>
  get(state[ALERT_MODULE_NAME], [EMAIL_STATE_NAME, 'isLoading']);

export const getAlertName = (state, alertName) => alertName;

export const getAlertSection = state =>
  get(state[ALERT_MODULE_NAME], [EMAIL_STATE_NAME, 'section']);

export const isAlertAlreadyCreatedSelector = createSelector(
  [getAlertName, getAlertsAlreadyCreated],
  (alertName, alertsCreated) => alertsCreated.includes(alertName)
);

export const isAlertAlreadyCreated = createSelector(
  [getSearchParameterWhatD, getAlertsAlreadyCreated],
  (whatD, alertsCreated) => alertsCreated.includes(whatD)
);



// WEBPACK FOOTER //
// ./app/Alerts/email/selectors.js